import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { DatatableModule } from '../../shared/components/datatable/datatable.module';
import { SpecialDatatableModule } from '../../shared/components/special-datatable/special-datatable.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ReportsRoutingModule } from './reports-routing.module';
import { ReportsMainComponent } from './reports-main/reports-main.component';
import { ReportsRawCampaignsDataComponent } from './reports-raw-campaigns-data/reports-raw-campaigns-data.component';
import { ReportsSimpleCampaignsComponent } from './reports-simple-campaigns/reports-simple-campaigns.component';
import { ReportsApiService } from './reports.apiservice';
import { WeeklyReportsComponent } from './weekly-reports/weekly-reports.component';
import { ReportsRollupMainComponent } from './reports-rollup-main/reports-rollup-main.component';
import { CampaignDatatableModule } from '../../shared/components/campaign-datatable/campaign-datatable.module';
import { ReportDatatableModule } from '../../shared/components/report-datatable/report-datatable.module';
import { ReportsRollupMainModule } from './reports-rollup-main/reports-rollup-main.module';
import { ReportsRollupWorkflowModule } from './reports-rollup-main/reports-rollup-workflow.module';
import { ReportsBrandReportModule } from './reports-brand-report/reports-brand-report.module';
import { ReportsBrandOverviewModule } from './reports-brand-overview/reports-brand-overview.module';
import { ReportViewModule } from './report-view/report-view.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [ 
    ReportsMainComponent,
    WeeklyReportsComponent,
    WeeklyReportsComponent, 
    ReportsSimpleCampaignsComponent,
    ReportsRawCampaignsDataComponent, 
  ],
  imports: [
    CommonModule,
    SharedModule,
    DatatableModule,
    SpecialDatatableModule,
    CampaignDatatableModule,
    ReportDatatableModule,
    ReportViewModule,
    ReportsRollupMainModule,
    ReportsRollupWorkflowModule,
    ReportsBrandReportModule,
    ReportsBrandOverviewModule,
    ReportsRoutingModule,
    DragDropModule, 
    TranslateModule
  ],
  providers:[ 
    ReportsApiService,
  ],
  exports: [
    ReportViewModule,
    ReportsRollupMainModule,
  ]
})
export class ReportsModule { }
